import { useState, useEffect } from 'react';
import {
    removeElements,
    addEdge,
    ArrowHeadType,
} from 'react-flow-renderer';

import MDRMCommonality from '../components/MDRMCommonality';
import { createElements } from './utils';

const MDRMCommonalityContainer = ({ primaryReport, relatedReports }) => {
    const initialElements = [];
    const [elements, setElements] = useState(initialElements);
    const [mainReport, setMainReport] = useState(primaryReport);
    const [crossReports, setCrossReports] = useState(relatedReports);

    const onLoad = _reactFlowInstance => _reactFlowInstance.fitView();

    const onElementsRemove = elementsToRemove => setElements(els => removeElements(elementsToRemove, els));

    const onConnect = params => setElements(els => addEdge({ ...params, type: 'floating', arrowHeadType: ArrowHeadType.Arrow }, els));

    useEffect(() => {
        setElements([]);
        setMainReport(primaryReport);
    }, [primaryReport]);

    useEffect(() => {
        setElements([]);
        setCrossReports(relatedReports);
    }, [relatedReports]);

    useEffect(() => {
        if (mainReport || crossReports) {
            setElements(createElements(mainReport, crossReports));
        }
    }, [mainReport, crossReports]);

    return (
        <MDRMCommonality
            elements={elements}
            onElementsRemove={onElementsRemove}
            onConnect={onConnect}
            onLoad={onLoad}
        />
    );
};

export default MDRMCommonalityContainer;
